import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { SubscriptionDocument } from '@/lib/types/subscription'
import type { DevSetPlanRequest } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Dev-only endpoint to force set a workspace subscription plan.
 */
export async function devSetPlan(
  request: DevSetPlanRequest,
): Promise<SubscriptionDocument> {
  const response = await AuthAxios.post<SubscriptionDocument>(
    `${ENDPOINT_SUBSCRIPTIONS}/dev-set-plan`,
    request,
  )
  return response.data
}
